import React from 'react';
import { Alert } from 'antd';
import { Colors, ColorsType } from 'works/legacy/lib/style-helper';
import { Icon, IconOfKind } from '@common/components';

type Props = {
  type: 'info' | 'success' | 'error' | 'warning' | 'neutral';
  content: string | React.ReactNode;
  closable?: boolean;
  fontSize?: string;
  showIcon?: boolean;
  style?: React.CSSProperties;
};

const typesData = {
  info: {
    baseColorHash: Colors.skyHyperLight,
    icon: 'circleInfo',
    iconColor: 'skyRegular',
  },
  success: {
    baseColorHash: Colors.meadowHyperLight,
    icon: 'circleCheck',
    iconColor: 'grassMid',
  },
  error: {
    baseColorHash: Colors.coralHyperlight,
    icon: 'circleXmark',
    iconColor: 'coral',
  },
  warning: {
    baseColorHash: Colors.sunLighter,
    icon: 'triangleExclamation',
    iconColor: 'sunDarker',
  },
  neutral: {
    baseColorHash: Colors.steelLightest,
    icon: 'circleExclamation',
    iconColor: 'midnightLighter',
  },
};

export const Banner: React.FC<Props> = ({
  content,
  type,
  closable,
  fontSize,
  showIcon = true,
  style,
}) => {
  const currentTypeData = typesData[type];
  const iconOfKind = {
    icon: currentTypeData.icon,
    kind: 'solid',
  } as IconOfKind;

  return (
    <>
      <Alert
        className="wk-banner"
        closable={closable}
        icon={
          <Icon
            {...iconOfKind}
            color={currentTypeData.iconColor as ColorsType}
          />
        }
        message={content || ''}
        showIcon={showIcon}
        style={{
          ...style,
          borderColor: currentTypeData.baseColorHash,
          backgroundColor: currentTypeData.baseColorHash,
          fontSize: fontSize,
        }}
      />
      <style jsx>{`
        :global(.wk-banner) {
          width: fit-content;
        }
        :global(.wk-banner.ant-alert.ant-alert-closable) {
          padding-right: 40px;
        }
      `}</style>
    </>
  );
};
